import type { EntrypointConfig, EntrypointConfigRaw } from '@/types/entrypoint'

export const normalizeEntrypointConfig = (raw: EntrypointConfigRaw): EntrypointConfig => ({
  hasCampaigns: raw.indicators.HAS_CAMPAIGNS,
  hasInvoices: raw.indicators.HAS_INVOICES,
})
